<template>
  <div class="empresas-container">
    <div class="container py-5">
      <div class="row justify-content-center">
        <div class="col-12 col-md-8 col-lg-6 text-center">
          <div class="text-center mb-4">
            <img src="../../public/img/logosidebar.png" class="img-fluid logo-img" alt="Latydo Logo" />
          </div>
          
          <div class="content-section mb-5">
            <h2 class="text-white mb-4">¿Deseas el servicio de Latydo para empresas?</h2>
            <p class="text-white mb-4">
              Podemos ofrecer los servicios médicos para tu empresa. Con Latydo, podrás agregar 
              y darle el beneficio a tus empleados, mejorando su bienestar y productividad con 
              acceso a atención médica de calidad.
            </p>
            <p class="text-white mb-4">
              <strong>Servicio exclusivo para tus empleados:</strong> Reserva un servicio médico 
              personalizado diseñado específicamente para las necesidades de tu equipo de trabajo.
            </p>
            <p class="text-white mb-4">
              <strong>Visitas periódicas a domicilio:</strong> Agenda visitas médicas regulares 
              a tu empresa para el control médico y exámenes de rutina de todo tu equipo, 
              ahorrando tiempo y aumentando la eficiencia.
            </p>
            <p class="text-white mb-4">
              <strong>Beneficios extensibles:</strong> La familia de tus empleados también puede 
              utilizar el servicio de Latydo, ampliando el bienestar más allá del entorno laboral 
              y fortaleciendo el compromiso con tu empresa.
            </p>
          </div>
          
          <div class="d-grid p-4">
            <a href="https://wa.me/+34617531274" 
               class="btn custom-btn d-flex align-items-center justify-content-center gap-2">
              <i class="bi bi-whatsapp"></i>
              Contáctanos por WhatsApp
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Empresas'
}
</script>

<style scoped>
.empresas-container {
  min-height: 100vh;
  background-color: #20C29D;
  display: flex;
  align-items: center;
}

.logo-img {
  max-width: 200px;
  margin: 0 auto;
}

.content-section {
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 30px;
  border: 2px solid rgba(255, 255, 255, 0.2);
}

.custom-btn {
  transition: all 0.3s ease;
  border-radius: 12px;
  font-weight: 600;
  padding: 20px;
  background-color: transparent;
  border: 2px solid white;
  color: white;
  font-size: 1.1rem;
}

.custom-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  background-color: rgba(255, 255, 255, 0.1);
}

.bi {
  font-size: 1.4rem;
}
</style>
